// extracted by mini-css-extract-plugin
export default {"wrapper":"NPY29YjQGZcJGx9bvunZ","multipleRows":"qdkqOqnzjaCD0SzvRmLZ"};